<template>
    <ui5-dialog
        class="hide-message"
        :class="type"
        ref="dialog"
        :modal="false"
    >
        <div class="container">
            <div class="message">
                {{ message }}
            </div>
            <div class="button-container" v-if="showCloseButton">
                <ui5-button @click="close">Close</ui5-button>
            </div>
        </div>
    </ui5-dialog>
</template>
<script>
export default {
    props: {
        type: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            message: '',
            callback: null,
            showCloseButton: false,
        };
    },
    methods: {
        show(message, callback = null, timeout = 3500) {
            this.message = message;
            this.callback = callback;
            this.showCloseButton = timeout == null;
            this.$refs.dialog.show();
            //There is no API way to disable modal, so do it manually
            this.$refs.dialog
                .getStaticAreaItemDomRef()
                .then((staticAreaItem) => {
                    const blockLayer =
                        staticAreaItem.querySelector('.ui5-block-layer');
                    blockLayer.style.opacity = 0;
                    const interval = window.setInterval(() => {
                        if (blockLayer.style.display != 'none') {
                            blockLayer.style.display = 'none';
                            window.clearInterval(interval);
                        }
                    }, 50);

                    const bodyInterval = window.setInterval(() => {
                        const body = window.document.body;

                        if (
                            body.classList.contains('ui5-popup-scroll-blocker')
                        ) {
                            body.classList.remove('ui5-popup-scroll-blocker');
                            window.clearInterval(bodyInterval);
                        }

                        const html = window.document.documentElement;

                        if (
                            html.classList.contains('ui5-popup-scroll-blocker')
                        ) {
                            html.classList.remove('ui5-popup-scroll-blocker');
                            window.clearInterval(bodyInterval);
                        }
                    }, 50);
                });

            // Only auto-close if timeout is provided (not null/undefined)
            if (timeout != null) {
                window.setTimeout(this.close, timeout);
            }
        },
        close() {
            this.message = '';
            this.showCloseButton = false;
            this.$refs.dialog
                .getStaticAreaItemDomRef()
                .then((staticAreaItem) => {
                    const blockLayer =
                        staticAreaItem.querySelector('.ui5-block-layer');
                    blockLayer.style.opacity = 0;
                    this.$refs.dialog.close();
                    if (this.callback) {
                        this.callback();
                    }
                });
        },
    },
};
</script>
